import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';
import { CheckIcon } from '@heroicons/react/outline';
import { Modal } from 'antd';
import React, { FC } from 'react';

interface Props {
  open: boolean;
  onOk?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | undefined;
  onCancel?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | undefined;
}

const CallBackSuccessModal: FC<Props> = ({ open, onOk, onCancel }) => {
  return (
    <Modal
      title={null} // Remove the title
      closable={false}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      footer={null}
    >
      <div className='flex justify-center pb-5'>
        <span className='w-12 h-12 md:w-20 md:h-20 rounded-full flex items-center justify-center border-[1px] md:border-[3px] border-[#194C1A] md:border-green-500 p-2'>
          <CheckIcon className='w-8 h-8 md:w-10 md:h-10 text-[#158216] md:text-green-500' />
        </span>
      </div>
      <p className='text-white text-2xl text-center mb-2'>Response Submitted</p>
      <p className='text-white/60 text-2xl text-center mb-8'>
        We will be in touch soon. Kindly check your mail.
      </p>
      <ButtonDefault
        onClick={onCancel}
        variant={ButtonVariants.WHITE}
        size={5}
        className='w-full'
      >
        Close
      </ButtonDefault>
    </Modal>
  );
};

export default CallBackSuccessModal;
